import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-my-form-dialog',
  templateUrl: './my-form-dialog.component.html',
  styleUrls: ['./my-form-dialog.component.scss']
})
export class MyFormDialogComponent implements OnInit {
  
  constructor(
    public dialogRef: MatDialogRef<MyFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) 
    { 

    }

  ngOnInit(): void {
  }


}
